import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const LogoutIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 20",
  path: (
    <>
      <Path
        d="M6.66667 5.83333L2.5 10M2.5 10L6.66667 14.1667M2.5 10L12.5 10M12.5 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H12.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

LogoutIcon.displayName = "LogoutIcon";
export { LogoutIcon };
